var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStarFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20758 1.13458C7.45758 0.367085 8.54341 0.367085 8.79258 1.13458L10.0584 5.02958C10.1129 5.19666 10.2188 5.34223 10.361 5.44551C10.5032 5.54878 10.6743 5.60446 10.8501 5.60459H14.9459C15.7534 5.60459 16.0884 6.63792 15.4359 7.11292L12.1226 9.51959C11.9803 9.62305 11.8743 9.76892 11.82 9.93628C11.7656 10.1036 11.7657 10.2839 11.8201 10.4513L13.0851 14.3463C13.3351 15.1146 12.4559 15.7529 11.8034 15.2779L8.49008 12.8713C8.34767 12.7677 8.17614 12.712 8.00008 12.712C7.82402 12.712 7.65249 12.7677 7.51008 12.8713L4.19675 15.2779C3.54425 15.7529 2.66508 15.1138 2.91508 14.3463L4.18008 10.4513C4.23448 10.2839 4.23451 10.1036 4.18017 9.93628C4.12583 9.76892 4.01991 9.62305 3.87758 9.51959L0.564246 7.11292C-0.0890872 6.63792 0.24758 5.60459 1.05425 5.60459H5.14925C5.32512 5.60463 5.4965 5.54903 5.63885 5.44575C5.7812 5.34247 5.88723 5.19679 5.94175 5.02958L7.20758 1.13458Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star-fill.0dde892da4ea1a3a80cab4d63db9ffef.svg";